if (window.Vue === undefined) {
    window.Vue = require('vue');
    window.Bus = new Vue();
}

import * as amplitude from '@amplitude/unified';
import Vapor from '@jgile/laravel-vue/resources/js/lib/Vapor';
import Vuex from 'vuex';
import MyMixins from '@js/components/shared/mixins/global';
import axios from 'axios';
import { Model } from 'vue-api-query';

amplitude.initAll('845203d2aa9847b3605776435e613294', { analytics: { autocapture: true }, sessionReplay: { sampleRate: 1 } });

window.Vapor = Vapor;
Model.$http = axios;

if (process.env.NODE_ENV === 'production') {
    require('./lib/production');
} else {
    require('./lib/dev');
}

require('./spark-components/spark-bootstrap');
require('./alpine/index');
require('./components/components');

Vue.use(MyMixins);
Vue.use(Vuex);
const store = new Vuex.Store(require('./store/store'));

new Vue({
    mixins: [require('./spark-components/spark')],
    store,
});
